import {
  MEDIA_ANALYSIS_HISTORY_CONDITION_CLEAR,
  convertConditionToAnalysisHistoryVars,
  useAnalysisHistoryApi,
  useMediaAnalysisHistorySearchCondition
} from '@/common/api/modules/mediaAnalysis'
import { useFirstLoading } from '@/common/api/search'
import { useSiteId } from '@/common/app/site'

import Area from '@/components/view/layouts/area/Area'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageListLoading from '@/components/view/molecules/loading/PageListLoading'
import PageListSearching from '@/components/view/molecules/loading/PageListSearching'
import NoResultGuidance from '@/components/view/molecules/search/NoResultGuidance'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import AppTitleBadge, { AppTitleBadgeType } from '@/components/container/layout/AppTitleBadge'
import MediaAnalysisHistoryListTable from '@/components/container/modules/media/analysisHistory/table/MediaAnalysisHistoryListTable'
import MediaAnalysisHistorySearchConditionField from '@/components/container/modules/media/analysisHistory/table/MediaAnalysisHistorySearchConditionField'
import TitlePageInfo from '@/components/container/utils/pager/TitlePageInfo'

// サイト現状分析 - 分析履歴一覧（検索：実行日時・種別・分析名／一覧：実行日時・ID・分析名・種別・状態・生成アクション）
const MediaAnalysisHistoryPage = () => {
  const siteId = useSiteId()
  const [condition, setCondition, onUpdatePage] = useMediaAnalysisHistorySearchCondition()

  const { data, isLoading } = useAnalysisHistoryApi(
    convertConditionToAnalysisHistoryVars(siteId, condition)
  )

  const isFirstLoading = useFirstLoading(isLoading)

  return (
    <Main type={MainLayoutType.MEDIUM}>
      <PageTitle
        title='分析履歴一覧'
        badgeNode={<AppTitleBadge type={AppTitleBadgeType.MEDIA} />}
        description='各分析の実行履歴を横断的に確認します。分析名から結果詳細、生成アクションから該当アクションへ遷移できます。'
        behindNode={
          data && (
            <TitlePageInfo
              page={condition.page}
              perPage={condition.perPage}
              total={data.total}
              unit='件'
            />
          )
        }
      />

      <Content>
        {isFirstLoading ? (
          <PageListLoading />
        ) : (
          <Area tableWrap noBorder>
            <MediaAnalysisHistorySearchConditionField
              condition={condition}
              setCondition={setCondition}
            />
            {isLoading ? (
              <PageListSearching />
            ) : data?.total ? (
              <MediaAnalysisHistoryListTable
                siteId={siteId}
                items={data.items}
                total={data.total}
                condition={condition}
                onUpdatePage={onUpdatePage}
              />
            ) : (
              <NoResultGuidance
                searched
                name='分析履歴'
                onClickReset={() => setCondition(MEDIA_ANALYSIS_HISTORY_CONDITION_CLEAR)}
              />
            )}
          </Area>
        )}
      </Content>
    </Main>
  )
}

export default MediaAnalysisHistoryPage
